jQuery(document).ready(function($) {
    const swiper = new Swiper('.logo-swiper', {
        loop: false,
        spaceBetween: 24,
        autoplay: {
            delay: 3000, // 3 seconds per slide
            disableOnInteraction: false // keep autoplay after user interaction
        },
        navigation: {
            nextEl: '.logo-swiper-wrap .swiper-button-next',
            prevEl: '.logo-swiper-wrap .swiper-button-prev',
        },
        pagination: {
            el: '.logo-swiper-wrap .swiper-pagination',
            type: 'progressbar',
        },
        slidesPerView: 2.5, // Mobile default
        breakpoints: {
            576: {
                slidesPerView: 3
            },
            992: {
                slidesPerView: 7
            }
        }
    });
});
